<template>
    <div>
        <div>
            <h5 class="font-weight-bold">{{$t('accommodation.roomPrice')}}</h5>
            <hr />
            <div class="row">
                <div class="form-group col-lg-3">
                    <label class="font-weight-bold">{{ $t('accommodation.single') }}</label>
                    <input type="number" class="form-control" v-model="accommodation.single">
                </div>
                <div class="form-group col-lg-3">
                    <label class="font-weight-bold">{{ $t('accommodation.double') }}</label>
                    <input type="number" class="form-control" v-model="accommodation.double">
                </div>
                <div class="form-group col-lg-3">
                    <label class="font-weight-bold">{{ $t('accommodation.triple') }}</label>
                    <input type="number" class="form-control" v-model="accommodation.triple">
                </div>
                <div class="form-group col-lg-3">
                    <label class="font-weight-bold">{{ $t('accommodation.apartment') }}</label>
                    <input type="number" class="form-control" v-model="accommodation.apartment">
                </div>
            </div>
        </div>
        <hr />
        <div class="row">
            <div class="form-group col-lg-6">
                <label class="font-weight-bold">{{ $t('accommodation.food') }}</label>
                <toggle v-model="accommodation.food"></toggle>
            </div>
            <div v-if="accommodation.food" class="form-group col-lg-6">
                <label class="font-weight-bold">{{ $t('accommodation.menu') }}</label>
                <multi-select :load-by-parent-sort="true"
                              :parent-sort="nomenclature.Menu"
                              v-model="accommodation.menuTypeIds"
                              :fieldName="$t('accommodation.menu')">
                </multi-select>
            </div>
        </div>
    </div>
</template>

<script>
    import MultiSelect from '../dropdown/MultiSelect';
    import appToggle from '../toggle/Toggle';
    import { NomenclatureParentBySort } from '../../models/enums';

    export default {
        inject: ['$validator'],
        props: {
            accommodation: {
                type: Object
            }
        },
        data() {
            return {
                nomenclature: NomenclatureParentBySort
            }
        },
        components: {
            'toggle': appToggle,
            'multi-select': MultiSelect
        }
    }
</script>
